import React, { useContext } from 'react';
import { Container, Row, Col, Table, Spinner, Form, InputGroup, Button, Accordion } from 'react-bootstrap';
import { AppContext } from '../App';


export const StaffTokenReport = () => {
	const { getDetailReport, detailReport, detailReportLoad, getDate, postCall, staffTokenReport, setStaffTokenReport, getLoad, setGetLoad, setViewBillModal, getBill } = useContext(AppContext);
	const getReport = (e) => {
		e.preventDefault();
		let start = e.target.start.value;
		let end = e.target.end.value;
		if (start !== "" && end !== "") {
			setGetLoad(true)
			postCall('api/bnr/get/staff/token/report/', { start_date: start, end_date: end }).then(res => {
				setStaffTokenReport(res.data);
				setGetLoad(false);
			}).catch(err => {
				setGetLoad(false);
			});
		}
	}
	return (
		<div className='container-fluid' >
			<div className="bgp grid4by6 br-3 p-2 align-items-center justify-content-between mb-2" >
				{
					getLoad ? (
						<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
					) : (
						<span>Staff wise token report</span>
					)
				}
				<Form onSubmit={getReport} >
					<Row>
						<Col xs={12} sm={4} md={4} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">From</InputGroup.Text>
								<Form.Control name="start" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={4} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">To</InputGroup.Text>
								<Form.Control name="end" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={4} className="d-grid" >
							<Button type="submit" className="btn-t1-r br-3" >Get Report</Button>
						</Col>
					</Row>
				</Form>
			</div>
			{

				staffTokenReport !== undefined && Object.keys(staffTokenReport).length > 0 ? (
					Object.keys(staffTokenReport).map((staff, s_i) => (
						<Accordion key={`custo_${s_i}`} className="mb-2" >
							<Accordion.Item eventKey="0">
								<Accordion.Header><span className="tp1 f18" >{`${staffTokenReport[staff].first_name} ${staffTokenReport[staff].last_name}, Username : ${staffTokenReport[staff].username}`}</span></Accordion.Header>
								<Accordion.Body>
									<Table bordered className="tbl-bg-blue" >
										<thead>
											<tr>
												<th><span className="tp2" >Date</span></th>
												<th><span className="tp2" >Customer</span></th>
												<th><span className="tp2" >Invoice</span></th>
												<th className="text-end tp2" ><span>SC</span></th>
												<th className="text-end tp2" ><span>TC</span></th>
												<th className="text-end tp2" ><span>Credit</span></th>
												<th className="text-end tp2" >Total</th>
											</tr>
										</thead>
										<tbody>
											{
												staffTokenReport[staff].bills !== undefined ? (
													Object.keys(staffTokenReport[staff].bills).length > 0 ? (
														Object.keys(staffTokenReport[staff].bills).map((bill, bill_i) => (
															<tr key={`bill_${bill_i}`}>
																<td>
																	<span className="tp2 mb-1 d-grid">Invoice : {staffTokenReport[staff].bills[bill].bill_id}</span>
																	<span onClick={() => {
																		getBill(staffTokenReport[staff].bills[bill].bill_id);
																		setViewBillModal(true);
																	}} className="view-bill-link mb-1 mx-0" >View bill</span>
																	<span className="tp2 d-grid py-1 f14">{staffTokenReport[staff].bills[bill].bill_date}, {staffTokenReport[staff].bills[bill].bill_time}</span>

																</td>
																<td>
																	<span className="tp2 d-grid">{staffTokenReport[staff].bills[bill].customer_name}</span>
																	<span className="tp2 d-grid">{staffTokenReport[staff].bills[bill].customer_phone}</span>

																</td>
																<td><span className="tp2">{staffTokenReport[staff].bills[bill].bill_id}</span></td>
																<td className="tp2 text-end"><span>{parseFloat(staffTokenReport[staff].bills[bill].service_amount_total).toFixed(2)}</span></td>
																<td className="tp2 text-end"><span>{parseFloat(staffTokenReport[staff].bills[bill].transaction_total).toFixed(2)}</span></td>
																<td className="tp2 text-end">
																	{
																		staffTokenReport[staff].bills[bill].credit_amount !== null && staffTokenReport[staff].bills[bill].credit_amount !== "" && staffTokenReport[staff].bills[bill].credit_amount > 0 ? (
																			staffTokenReport[staff].bills[bill].credit_status ? (
																				<span className="sucess-tag mx-2"><i className="bi bi-check-circle"></i> Paid</span>
																			) : (

																				<span className="error-message mx-2"><i className="bi bi-x-circle"></i> Pending</span>
																			)
																		) : ''
																	}
																	<span>{parseFloat(staffTokenReport[staff].bills[bill].credit_amount).toFixed(2)}</span>
																</td>
																<td className="tp2 text-end"><span>{parseFloat(staffTokenReport[staff].bills[bill].bill_total).toFixed(2)}</span></td>
															</tr>
														))
													) : ''
												) : ''
											}
											<tr>
												<td colSpan={3} className="text-end bgy"><span className='f20' >Total</span></td>
												<td className="text-end bgy" ><span className='f20' >{parseFloat(staffTokenReport[staff].serv_bills_total).toFixed(2)}</span></td>
												<td className="text-end bgy" ><span className='f20' >{parseFloat(staffTokenReport[staff].trans_bills_total).toFixed(2)}</span></td>
												<td className="text-end bgy" ><span className='f20' >{parseFloat(staffTokenReport[staff].credit_bills_total).toFixed(2)}</span></td>
												<td className="text-end bgy" ><span className='f20' >{parseFloat(staffTokenReport[staff].bills_total).toFixed(2)}</span></td>
											</tr>
										</tbody>
									</Table>
								</Accordion.Body>
							</Accordion.Item>
						</Accordion>
					))
				) : 'Report Not found!'
			}
		</div>
	)
}